import { useEffect, useState } from 'react'
import clsx from 'clsx'

import { Popup } from '@/ui/Popup'
import { DatePickerMileage } from '@/ui/DatePicker'
import styles from './DateInput.module.scss'
import ArrowIcon from '../assets/arrow.svg'
import { formatDate } from '../utils/formatDate'
import { useDateStore } from '../store'

const POPUP_OFFSET = 12

export const DateInputMileage = () => {
    const { date, setDate } = useDateStore()
    const [selectedDate, setSelectedDate] = useState(date ? new Date(date) : new Date())

    const handleDateChange = (date: Date) => {
        setSelectedDate(date)
        setDate(date)
    }

    useEffect(() => {
        setSelectedDate(new Date(date))
    }, [date])

    return (
        <Popup
            offset={POPUP_OFFSET}
            placement="bottom-start"
            className={styles.popup}
            triggerComponent={(isOpen) => (
                <div className={styles.selectContainerMileage}>
                    <span className={styles.labelMileage}>{formatDate(selectedDate)}</span>
                    <button className={clsx(styles.triggerButtonMileage, { [styles.open]: isOpen })}>
                        <ArrowIcon />
                    </button>
                </div>
            )}
            focusDismiss={false}
        >
            <DatePickerMileage value={selectedDate} onChange={handleDateChange} />
        </Popup>
    )
}
